import React, { useContext, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { isEqual, get } from 'lodash';
import { bindActionCreators } from 'redux';

import resourcesConfig from '../../resources';
import asyncRoute from '../../helpers/hoc/asyncRoute';
import ThemeContext from '../../containers/ThemeContext';
import rewardsRoutes from '../../routes/rewards';

import './LocationPickerAnimation.scss';

const LocationPermissionDenialCard = asyncRoute(() =>
  import('../Card/LocationPermissionDenialCard'),
);
const Icons = asyncRoute(() => import('../Icons'));

const LocationPickerAnimation = ({ history, setShowLocationAnimation, guestLocationDetails }) => {
  const { fetchingLocation, guestLocation, locationPermissionStatus } = useContext(ThemeContext);
  const { addressName, address } = guestLocationDetails || {};
  const [animationFinished, setAnimationFinished] = useState(false);
  const mountedRef = useRef(true);

  useEffect(() => {
    if (!mountedRef.current) return;

    if (isEqual(locationPermissionStatus, 'granted') && !animationFinished) {
      // Simulate animation finish after location is fetched
      if (!fetchingLocation && guestLocation) {
        setTimeout(() => {
          if (mountedRef.current) {
            // To Do: Add animation finish logic
            setAnimationFinished(true);
          }
        }, 1000);
      }
    }
  }, [locationPermissionStatus, fetchingLocation, guestLocation, animationFinished]);

  useEffect(() => {
    if (!fetchingLocation && animationFinished) {
      setTimeout(() => {
        // Remove Location Screen After Displaying Location Details for 1.5 seconds
        setShowLocationAnimation(false);
      }, 1500);
    }
  }, [fetchingLocation, animationFinished]);

  const handleProceedCTA = () => {
    setShowLocationAnimation(false);
  };

  const handleChangeLocationCTA = () => {
    history.push(`${rewardsRoutes.containers.location}`);
    setShowLocationAnimation(false);
  };

  return (
    <div className="location-picker-animation">
      <div className="location-picker-animation_content">
        {!isEqual(locationPermissionStatus, 'denied') &&
        (fetchingLocation || !animationFinished) ? (
          <>
            <div className="location-picker-animation_image">
              <Icons type="location" />
            </div>
            {/* To Do: Location Animation Loader */}
            <div className="location-picker-animation_title">
              <FormattedMessage
                id="identifyingLocation"
                defaultMessage={resourcesConfig.identifyingLocation}
              />
            </div>
          </>
        ) : isEqual(locationPermissionStatus, 'denied') ? (
          <LocationPermissionDenialCard
            handleCTAClick={() => handleChangeLocationCTA(true)}
            buttonCTA={
              <FormattedMessage
                id="selectLocationManually"
                defaultMessage={resourcesConfig.selectLocationManually}
              />
            }
          />
        ) : (
          <>
            <div className="location-picker-animation_image">
              <Icons type="location" />
            </div>

            {addressName && <div className="location-picker-animation_title">{addressName}</div>}
            {address && (
              <div className="location-picker-animation_locality-container">
                <div className="location-picker-animation_locality-text">{address}</div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  serviceTypeConfig: get(state, 'common.resources.serviceTypeConfig', {}),
  brandResources: get(state, 'common.resources', {}),
  guestLocationDetails: get(state, 'common.guestLocation', {}),
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({}, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationPickerAnimation);
